import {
  o,
  r
} from "./chunk.4JTBA2KG.js";

// src/components/button/button-standard.styles.ts
var variants = ["primary", "secondary", "tertiary", "neutral", "success", "warning", "danger"];
function generateButtonVariants() {
  return o(variants.slice().map((variant) => {
    return ` .button--standard.button--${variant} { background: var(--btn-bg-${variant}); } .button--standard.button--${variant}.button--hover:not(.button--disabled) { background: var(--sl-color-${variant}-500); background-image: none; } .button--standard.button--${variant}:not(.button--disabled) .button__interior:active, .button--standard.button--${variant}.button--active:not(.button--disabled) .button__interior, .button--standard.button--${variant}:not(.button--disabled) .button__interior:focus-visible { background: var(--sl-color-${variant}-700); } `;
  }).join(""));
}
var button_standard_styles_default = r` .button--standard .button__interior { background: none; color: var(--sl-color-neutral-0); } .button:not(.button--disabled):has(:focus-visible) { box-shadow: var(--sl-focus-ring); } ${generateButtonVariants()} `;

export {
  button_standard_styles_default
};
